/**
 * Payout preset templates for division classes.
 *
 * A preset is a one-click producer shortcut that sets three things at
 * once: `division_pool_pct` (money split %), `division_splits` (seconds
 * behind fastest per division), and `division_places` (places paid per
 * division). Producers who run the same show format repeatedly can pick
 * a preset from the dropdown instead of hand-typing every field.
 *
 * Structure per division type:
 *   { id, label, description, poolPct, splits, places }
 *
 * `poolPct.total` must equal 100. `splits[0]` must be 0 (leader).
 */

export const PAYOUT_PRESETS = {
  '4D': [
    {
      id: 'standard-4d',
      label: 'Standard 4D',
      description: '0 / 0.5 / 1.0 / 2.0 · 40/30/20/10',
      poolPct: { '1D': 40, '2D': 30, '3D': 20, '4D': 10 },
      splits: [0, 0.5, 1.0, 2.0],
      places: { '1D': 1, '2D': 1, '3D': 1, '4D': 1 },
    },
    {
      id: 'wide-4d',
      label: 'Wide 4D',
      description: '0 / 1 / 2 / 3 · 40/30/20/10',
      poolPct: { '1D': 40, '2D': 30, '3D': 20, '4D': 10 },
      splits: [0, 1.0, 2.0, 3.0],
      places: { '1D': 1, '2D': 1, '3D': 1, '4D': 1 },
    },
    {
      id: 'nbha-4d',
      label: 'NBHA 4D',
      description: '0 / 0.5 / 1.0 / 2.0 · Standard NBHA split',
      poolPct: { '1D': 40, '2D': 30, '3D': 20, '4D': 10 },
      splits: [0, 0.5, 1.0, 2.0],
      places: { '1D': 4, '2D': 3, '3D': 2, '4D': 1 },
    },
    {
      id: 'even-4d',
      label: 'Even 4D',
      description: '0 / 0.5 / 1.0 / 2.0 · 25/25/25/25',
      poolPct: { '1D': 25, '2D': 25, '3D': 25, '4D': 25 },
      splits: [0, 0.5, 1.0, 2.0],
      places: { '1D': 1, '2D': 1, '3D': 1, '4D': 1 },
    },
    {
      id: 'top-heavy-4d',
      label: 'Top-Heavy 4D',
      description: '0 / 0.5 / 1.0 / 2.0 · 50/25/15/10',
      poolPct: { '1D': 50, '2D': 25, '3D': 15, '4D': 10 },
      splits: [0, 0.5, 1.0, 2.0],
      places: { '1D': 1, '2D': 1, '3D': 1, '4D': 1 },
    },
  ],
  '3D': [
    {
      id: 'standard-3d',
      label: 'Standard 3D',
      description: '0 / 1 / 2 · 50/30/20',
      poolPct: { '1D': 50, '2D': 30, '3D': 20 },
      splits: [0, 1.0, 2.0],
      places: { '1D': 1, '2D': 1, '3D': 1 },
    },
    {
      id: 'wide-3d',
      label: 'Wide 3D',
      description: '0 / 1.5 / 3 · 50/30/20',
      poolPct: { '1D': 50, '2D': 30, '3D': 20 },
      splits: [0, 1.5, 3.0],
      places: { '1D': 1, '2D': 1, '3D': 1 },
    },
    {
      id: 'even-3d',
      label: 'Even 3D',
      description: '0 / 1 / 2 · 34/33/33',
      poolPct: { '1D': 34, '2D': 33, '3D': 33 },
      splits: [0, 1.0, 2.0],
      places: { '1D': 1, '2D': 1, '3D': 1 },
    },
  ],
  '2D': [
    {
      id: 'standard-2d',
      label: 'Standard 2D',
      description: '0 / 0.5 · 60/40',
      poolPct: { '1D': 60, '2D': 40 },
      splits: [0, 0.5],
      places: { '1D': 1, '2D': 1 },
    },
    {
      id: 'wide-2d',
      label: 'Wide 2D',
      description: '0 / 1 · 60/40',
      poolPct: { '1D': 60, '2D': 40 },
      splits: [0, 1.0],
      places: { '1D': 1, '2D': 1 },
    },
    {
      id: 'even-2d',
      label: 'Even 2D',
      description: '0 / 0.5 · 50/50',
      poolPct: { '1D': 50, '2D': 50 },
      splits: [0, 0.5],
      places: { '1D': 1, '2D': 1 },
    },
  ],
};
